import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { IdentityUser } from '@model/identity';

@Component({
  selector: 'app-user-profile-dialog',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  template: `
    <div class="p-4 sm:p-6 w-[90vw] max-w-[360px]">
      <!-- Avatar e info principal -->
      <div class="flex flex-col items-center mb-6">
        <div
          class="w-20 h-20 rounded-full bg-sura-blue-500 flex items-center justify-center text-white text-2xl font-bold mb-3"
        >
          {{ iniciales }}
        </div>
        <h2 class="text-xl font-bold text-gray-800 dark:text-gray-100">
          {{ user.fullName }}
        </h2>
        <p class="text-sm text-gray-500 dark:text-gray-400">
          {{ user.username }}
        </p>
      </div>

      <!-- Detalles -->
      <div class="space-y-3 mb-6">
        <div
          class="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg"
          *ngIf="user.username"
        >
          <i class="pi pi-user text-sura-blue-500 dark:text-sura-blue-300"></i>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Usuario</p>
            <p class="text-sm font-medium text-gray-800 dark:text-gray-100">
              {{ user.username }}
            </p>
          </div>
        </div>

        <div
          class="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg"
          *ngIf="user.lastAccess"
        >
          <i class="pi pi-clock text-sura-blue-500 dark:text-sura-blue-300"></i>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">
              Último acceso
            </p>
            <p class="text-sm font-medium text-gray-800 dark:text-gray-100">
              {{ user.lastAccess }}
            </p>
          </div>
        </div>
      </div>

      <!-- Botón cerrar -->
      <div class="flex justify-end sm:justify-start">
        <button
          pButton
          type="button"
          label="Cerrar"
          severity="secondary"
          (click)="close()"
        ></button>
      </div>
    </div>
  `
})
export class UserProfileDialogComponent {
  private dialogRef = inject(DynamicDialogRef);
  private dialogConfig = inject(DynamicDialogConfig);

  user: IdentityUser;
  iniciales: string;

  constructor() {
    this.user =
      (this.dialogConfig.data as { user: IdentityUser })?.user ??
      ({} as IdentityUser);
    this.iniciales = this.getIniciales(this.user.fullName);
  }

  close(): void {
    this.dialogRef.close();
  }

  private getIniciales(fullName: string): string {
    if (!fullName) return '?';
    const partes = fullName.trim().split(/\s+/);
    return partes
      .slice(0, 2)
      .map((p) => p.charAt(0))
      .join('')
      .toUpperCase();
  }
}
